import { useCallback } from 'react';
import PropTypes from 'prop-types';
import get from 'transmute/get';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const SubjectInput = ({
  onChange,
  onFocus,
  value = '',
  settings = {
    editable: true,
    required: false
  }
}) => {
  const handleChange = useCallback(({
    target: {
      value: nextValue
    }
  }) => {
    onChange(nextValue);
  }, [onChange]);
  return /*#__PURE__*/_jsx(View, {
    flex: 1,
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(TextInput, {
        styled: false,
        disabled: !get('editable', settings),
        onChange: handleChange,
        onFocus: onFocus,
        value: value,
        type: "text"
      })
    })
  });
};
SubjectInput.displayName = 'SubjectInput';
SubjectInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  settings: PropTypes.object,
  value: PropTypes.string
};
export default SubjectInput;